module.exports = __webpack_public_path__ + "static/media/jt.a6a652a8.jpg";